<div class="col-12">
  <div class="addFile" (click)="addFile()">
    <div>Subir archivo adjunto</div>
  </div>
  <div class="files">
    <div *ngFor="let file of files">
      <case-file-item
        [file]="file"
        (deleteFile)="delete($event)"
      ></case-file-item>
    </div>
  </div>
</div>
